import { auth, db } from "./firebase";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export async function getUserProfile(uid) {
  const snap = await getDoc(doc(db, "users", uid));
  return snap.exists() ? { uid, ...snap.data() } : null;
}

export async function login(email, password) {
  const cred    = await signInWithEmailAndPassword(auth, email, password);
  const profile = await getUserProfile(cred.user.uid);
  if (!profile) throw new Error("User profile not found. Contact your admin.");

  // Admins skip email verification requirement
  if (profile.role !== "admin" && !cred.user.emailVerified) {
    await signOut(auth);
    throw new Error("Please verify your email before signing in.");
  }

  return profile;
}

export async function logout() {
  await signOut(auth);
}

export function onAuthChanged(cb) {
  return onAuthStateChanged(auth, async (user) => {
    if (user) {
      const profile = await getUserProfile(user.uid);
      // Block unverified non-admin users
      if (profile && profile.role !== "admin" && !user.emailVerified) {
        await signOut(auth);
        cb(null);
        return;
      }
      cb(profile);
    } else {
      cb(null);
    }
  });
}
